<template>
  <div 
    v-if="active" 
    id="pdf-modal" 
    :class="{'is-active': active}"
    class="ec-modal ec-pdf-modal"
    @click.self="closeModal">
    <div class="ec-modal-main is-loading animated fadeIn blue-border">
      <div>
        <a 
          :href="pdf"
          class="btn is-blue pdf-download-btn"
          target="_blank">{{ $t('modals.pdf.download_btn') }}</a>
      </div>
      <a 
        href="#" 
        class="close-icon modal-close"
        @click.stop.prevent="closeModal" /> 
      <div 
        id="pdf-view" 
        class="pdf-view">
          <iframe :src="pdf" width="100%" height="100%"></iframe>
          <canvas id="pdf-view-canvas" />
      </div>
    </div>
  </div>
</template>

<script>
    import Modal from './Modal.mixin.vue'

    export default {
        el: '#pdfModal-mountable',
        mixins: [Modal],        
        data: function () {
            return {
                pdf: null
            }
        },
        mounted() {
            this.$event.$on('display-pdf', (payload) => {
                this.pdf = payload.pdf
                this.active = true
            })
        },
        methods: {
            renderPdf(pdfLink) {
                pdfjsLib.getDocument(pdfLink).then(function(pdf) {
                    pdf.getPage(1).then(function(page) {
                        const canvas = document.getElementById('pdf-view-canvas')

                        let viewport = page.getViewport(1.5)
                        canvas.height = viewport.height
                        canvas.width = viewport.width

                        page.render({
                            canvasContext: canvas.getContext('2d'),
                            viewport: viewport
                        })

                        /* align-items: center; */
                        canvas.style.height = canvas.height+'px'
                    })
                })
            },
            renderPage(page) {
              var viewport = page.getViewport(options.scale);
              var canvas = document.createElement('canvas');
              var ctx = canvas.getContext('2d');
              var renderContext = {
                canvasContext: ctx,
                viewport: viewport
              };
              
              canvas.height = viewport.height;
              canvas.width = viewport.width;
              canvasContainer.appendChild(canvas);
              
              page.render(renderContext);
          },    
          renderPages(pdfDoc) {
              for(var num = 1; num <= pdfDoc.numPages; num++)
                  pdfDoc.getPage(num).then(this.renderPage);
          }
        }
    }
</script>
